import {
  Dialog,
  DialogActions,
  DialogContent,
  css,
  styled,
} from '@mui/material'

import { hubloTheme } from '@front/theme'

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop: string) => !prop.startsWith('$'),
})<{
  $variant: 'default' | 'fullScreenOnMobile' | 'bottomSheet'
}>`
  &.MuiDialog-root .MuiDialog-container .MuiDialog-paper {
    padding: unset;
    ${hubloTheme.breakpoints.down('sm')} {
      ${({ $variant }) =>
        $variant === 'bottomSheet' &&
        css`
          position: absolute;
          width: 100%;
          border-radius: 24px 24px 0 0;
          bottom: 0;
          margin: 0;
          padding-bottom: ${hubloTheme.spacing(1)};
        `};
    }

    > .MuiTypography-root {
      padding: ${hubloTheme.spacing(2)};
    }

    ${hubloTheme.breakpoints.up('sm')} {
      /* desktop */
      width: 568px;
      height: auto;
    }

    ${({ $variant }) =>
      $variant === 'fullScreenOnMobile' &&
      css`
        ${hubloTheme.breakpoints.down('sm')} {
          width: 100%;
        }
      `}
  }
`

export const StyledDialogContent = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== 'withGutters',
})<{
  withGutters: boolean
}>`
  ${({ withGutters }) =>
    withGutters &&
    css`
      &.MuiDialogContent-root {
        padding: ${hubloTheme.spacing(0, 2)};
      }
    `}
`

export const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    padding: ${hubloTheme.spacing(0, 2)};
  }
`
